import { magentoApi } from "./magentoApi";

export function fetchCategoryTree(customerGroupId, isBundleOnly) {
  return magentoApi.get(
    `canon/categoryTree?customerGroupId=${customerGroupId}&isBundleOnly=${
      isBundleOnly ? 1 : 0
    }`
  );
}

export function fetchCategoryStaticBlock(categoryId) {
  return magentoApi.get(`canon/categoryStaticBlock?categoryId=${categoryId}`);
}

export async function fetchCategoryProducts(
  categoryId,
  customerGroupId,
  isBundleOnly
) {
  const response = await magentoApi.get(
    `canon/category/products?categoryId=${categoryId}&customerGroupId=${customerGroupId}&page=0&pageSize=0&isBundleOnly=${
      isBundleOnly ? 1 : 0
    }`
  );

  if (response.message) {
    throw new Error(response.message);
  }

  return response;
}

export function fetchProduct(sku, customerGroupId, accountId, financeType, financeSubType) {
  return magentoApi.get(
    `canon/product?sku=${sku}&customerGroupId=${customerGroupId}&accountId=${accountId}&financeType=${financeType}&financeSubType=${financeSubType}`
  );
}
